import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { BookedFlightItineraryWithDepartureTime } from "redmond";
import { resetFetchFlightCfarCancellationInfo } from "../../../../actions/actions";
import {
  getFetchFlightCfarInfoCallExpires,
  getSelectedFlightCfarItineraryId,
} from "../../../../reducer";

export const useRefreshFlightCfarPolicy = (
  flightItinerary: BookedFlightItineraryWithDepartureTime,
  options: {
    enabled: boolean;
  }
) => {
  const dispatch = useDispatch();
  const flightCfarCancellationPolicyCallExpires = useSelector(
    getFetchFlightCfarInfoCallExpires
  );
  const selectedFlightCfarItineraryId = useSelector(
    getSelectedFlightCfarItineraryId
  );

  const isCallExpired = useMemo(
    () =>
      flightCfarCancellationPolicyCallExpires != null &&
      flightCfarCancellationPolicyCallExpires < Date.now(),
    [flightCfarCancellationPolicyCallExpires]
  );

  const isDifferentItinerary = useMemo(
    () => selectedFlightCfarItineraryId !== flightItinerary.bookedItinerary.id,
    [selectedFlightCfarItineraryId, flightItinerary.bookedItinerary.id]
  );

  useEffect(() => {
    if (!options.enabled) {
      return;
    }

    if (isCallExpired || isDifferentItinerary) {
      dispatch(resetFetchFlightCfarCancellationInfo());
    }
  }, [isCallExpired, isDifferentItinerary, dispatch, options.enabled]);
};
